import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.POLICIES_LIST, { params: payload }),
    getSimilarPolicies: payload => axios.get(HTTP.SIMILAR_POLICIES_LIST, { params: payload }),
    getParentList: payload => axios.get(HTTP.POLICY_PARENT_LIST, { params: payload }),
    updateRightParamSet: payload => axios.put(HTTP.POLICY_RIGHT_PARAM_SET, payload),
    getPolicy: payload => axios.get(HTTP.POLICY, { params: payload }),
    addPolicy: payload => axios.post(HTTP.POLICY, payload),
    updatePolicy: payload => axios.put(HTTP.POLICY, payload),
    updateField: payload => axios.put(HTTP.POLICY_FIELD, payload),
    getPoliciesById: params => axios.post(HTTP.POLICIES_BY_ID, { params }),
    getRelevantPolicies: params => axios.post(HTTP.RELEVANT_POLICIES, { params }),
    getNullPolAtCases: () => axios.get(HTTP.NULL_POLICY),
    comparePolicies: payload => axios.patch(HTTP.POLICY, { payload })
}
